import { Gender } from '@pia/pia.shared';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'salutationPipe',
  pure: true,
})
export class SalutationPipe implements PipeTransform {
  transform(item: Gender): string {
    let title = '';
    switch (item) {
      case Gender.Female:
        title = 'Frau';
        break;
      case Gender.Male:
        title = 'Herr';
        break;
      case Gender.Other:
        title = 'Person';
    }
    return title;
  }
}
